import { render } from "./UpdateCompressDedup.vue?vue&type=template&id=2f847089&scoped=true"
import script from "./UpdateCompressDedup.vue?vue&type=script&lang=js"
export * from "./UpdateCompressDedup.vue?vue&type=script&lang=js"

import "./UpdateCompressDedup.vue?vue&type=style&index=0&id=2f847089&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f847089"]])

export default __exports__